// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_fN","advertDetailContacts__header":"c-n_fO"};